import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, ReferenceRateUnit, PjkTariff, ReferenceAdjustmentType, PayableOver, ReferenceRateBase } from "__generated__/graphql";

export const PjkSchema: RegistryItem = {
	[AgreementTypeEnum.Pjk]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.ReferenceRate,
				referenceRateUnit: ReferenceRateUnit.Pjk,
				pjkTariff: PjkTariff.Average,
				adjustmentType: ReferenceAdjustmentType.Flatprice,
				payableOver: PayableOver.Actual,
				referenceRateBase: ReferenceRateBase.Route,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.costType": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.referenceRateUnit": { rules: { hidden: true } },
			"calculationMethod.minimumPrice": { rules: { hidden: true } },
			"calculationMethod.minimumQuantityPayable": { rules: { hidden: true } },
			"calculationMethod.referenceRateBase": { rules: { hidden: true } },
		},
	},
};
